/** Legacy sidebar/DB paths → current React routes (see migrate_screens_to_reports_routes.sql). */
export const SCREEN_ROUTE_ALIASES = Object.freeze({
  '/examination/activitiesMarks': '/examination/ActivtiesMarks',
  /* Sub-screen reached from تعديل علامات طالب; it has no DB screen of its own. */
  '/examination/previous-years': '/examination/update-student-marks',
  '/examination/second-trial-required': '/reports/second-trial-required',
  '/registration/graduate-statistics': '/reports/graduate-statistics',
  '/registration/student-names': '/reports/student-names',
  '/registration/student-statistics': '/reports/student-statistics',
  '/examination/success-rate': '/reports/success-rate',
  '/examination/subject-effort-report': '/reports/subject-effort-report',
  '/examination/master-sheet': '/reports/master-sheet',
  '/registration/newstudents/form': '/registration/newstudents',
  '/endorsementcontinuation': '/student/endorsementcontinuation',
  /* Dedicated delete screen; falls back to student personal data until its own NACL row exists. */
  '/registration/remove-student': '/registration/studentpersonaldata',
  '/published_documents': '/registration/published_documents',
})

/** Resolve pathname for React Router matching (legacy → canonical). */
export const resolveCanonicalRoute = (pathname = '') => SCREEN_ROUTE_ALIASES[pathname] ?? pathname
